import React, { useEffect } from "react";
import { X } from "lucide-react";
import useClickOutsideModal from "../common/useClickOutsideModal";

const DeleteCourseModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  const modalRef = useClickOutsideModal(onClose);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#1F1B24]/70 px-4">
      <div
        ref={modalRef}
        className="relative w-full max-w-[447px] rounded-[19px] bg-white pt-5 pb-12 pr-8 pl-[38px]"
      >
        <button
          type="button"
          aria-label="Close delete confirmation"
          className="absolute right-8 top-5 text-[#151515]"
          onClick={onClose}
        >
          <X size={20} />
        </button>

        <p className="pt-10  leading-[19px] text-base text-black">
          Do you want to delete this Course?
        </p>

        <div className="mt-[19px] flex items-center justify-center gap-10">
          <button
            type="button"
            onClick={onClose}
            className="min-w-[99px] rounded-full bg-[#D9D9D9] px-6 py-1 text-[15px] text-black"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="min-w-[99px] rounded-full bg-[#923D8C] px-6 py-1 text-[15px] text-white disabled:opacity-70"
          >
            {isLoading ? "Deleting..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteCourseModal;
